import { StatisticValueStatusEnum } from '../../enums/statistic-value-status.enum';

export interface IDestinationRankingSchema {
    rank: number;
    rankDiff: number | null;
    locationName: string;
    deliveries: number | null;
    totalDeliveries: number | null;
    deliveriesRate: string | null;
    deliveriesRateStatus: StatisticValueStatusEnum | null;
    visitsWithEntry: number;
    totalVisits: number;
    visitsRate: string;
    visitsRateStatus: StatisticValueStatusEnum;
    participationRate: string;
    visitCount: number;
    punctualityRate: string | null;
    punctualityRateDiff: number | null;
    punctualityRateStatus: StatisticValueStatusEnum | null;
    dwellTime: string | null;
    dwellTimeDiff: string | null;
    dwellTimeDiffNumeric: number | null;
}
